import axios from "axios";

import useUserStore from "./useUserStore";

const sendRequest = (options = {}) => {
  const { token } = useUserStore.getState();

  let defaultConfig = {
    url: "/",
    method: "get",
    timeout: 10000,
    data: {},
    headers: {
      Authorization: `Bearer ${token || ""}`,
    },
    validateStatus: (status) => status >= 200 && status < 500,
  };

  // mix defaultConfig with options
  const requestConfig = {
    ...defaultConfig,
    ...options,
  };

  return axios(requestConfig);
};

export default sendRequest;
